<template>
  <div>
    <div class="breadcrumbs">
      <div class="container">
        <a href="/">首页</a> <span class="sep">/</span> <span>交易订单</span>
      </div>
    </div>
    <div class="mi-orderlist">
      <div class="container ">
        <div class="row">
          <div class="span4">
            <left-nav></left-nav>
          </div>
          <div class="span16">
            <div class="uc-box uc-main-box">
              <div class="uc-content-box order-list-box">
                <div class="box-hd">
                  <h1 class="title">
                    消息通知
                  </h1>
                  <div class="more clearfix">
                    <ul class="filter-list">
                      <li
                        class="first"
                        :class="getTabClass('ALL')"
                        @click="onClickTab('ALL')"
                      >
                        <a
                          data-stat-id="57897755adc8c1e0"
                          href="javascript:void(0);"
                          >全部消息</a
                        >
                      </li>
                      <li
                        :class="getTabClass('TO_REPLY')"
                        @click="onClickTab('TO_REPLY')"
                      >
                        <a href="javascript:void(0);">
                          物流动态
                        </a>
                      </li>
                      <li
                        :class="getTabClass('TO_ORDER')"
                        @click="onClickTab('TO_ORDER')"
                      >
                        <a href="javascript:void(0);">
                          优惠活动
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="box-bd" v-loading="is_loading">
                  <el-empty
                    description="暂无数据"
                    v-show="table_data.length === 0"
                  ></el-empty>
                  <div>
                    <ul class="order-list">
                      <li
                        data-v-1df9de88=""
                        class="uc-order-item uc-order-item-finish"
                        v-for="(item, index) in table_data"
                        :key="index"
                      >
                        <div
                          data-v-1df9de88=""
                          class="order-remove"
                          @click="onDel(item, index)"
                        >
                          <img
                            data-v-1df9de88=""
                            src="//i1.mifile.cn/f/i/2019/order/trash.png"
                            alt="垃圾桶"
                          />
                        </div>
                        <div
                          data-v-059c1862=""
                          data-v-1df9de88=""
                          class="order-detail"
                        >
                          <div data-v-059c1862="" class="order-summary">
                            <div data-v-059c1862="" class="order-status">
                              {{ item.status_text }}
                              <!---->
                            </div>
                            <!----><!---->
                          </div>
                          <table data-v-059c1862="" class="order-detail-table">
                            <thead data-v-059c1862="">
                              <tr data-v-059c1862="">
                                <th data-v-059c1862="" class="col-main">
                                  <p data-v-059c1862="" class="caption-info">
                                    {{ item.create_time }}
                                    <span data-v-059c1862="" class="sep"
                                      >|</span
                                    >
                                    {{ item.user_name }}
                                    <span data-v-059c1862="" class="sep"
                                      >|</span
                                    >
                                    订单号：<span data-v-059c1862="">{{
                                      item.order_no
                                    }}</span
                                    ><span data-v-059c1862="" class="sep"></span
                                    ><!---->
                                  </p>
                                </th>
                                <th
                                  data-v-059c1862=""
                                  class="col-sub"
                                  style="padding-bottom:7px;"
                                >
                                  <p data-v-059c1862="" class="caption-price">
                                    总价：
                                    <span
                                      data-v-059c1862=""
                                      style="width:90px;display:inline-block;color:red;font-weight:bold;font-size:16px;"
                                      >{{ item.total_amount }}</span
                                    >
                                    元
                                  </p>
                                  <p data-v-059c1862="" class="caption-price">
                                    优惠：
                                    <span
                                      data-v-059c1862=""
                                      style="width:90px;display:inline-block;color:red;font-weight:bold;font-size:16px;"
                                      >{{ item.discount }}</span
                                    >
                                    元
                                  </p>
                                  <p data-v-059c1862="" class="caption-price">
                                    最终：
                                    <span
                                      style="width:90px;display:inline-block;color:red;font-weight:bold;font-size:16px;"
                                      >{{ item.final_amount }}</span
                                    >
                                    元
                                  </p>
                                </th>
                              </tr>
                            </thead>
                            <tbody data-v-059c1862="">
                              <tr data-v-059c1862="">
                                <td data-v-059c1862="" class="order-items">
                                  <ul data-v-059c1862="" class="goods-list">
                                    <li
                                      data-v-1e04aab1=""
                                      data-v-059c1862=""
                                      v-for="(child, index) in item.item_list"
                                      :key="index"
                                    >
                                      <div
                                        data-v-1e04aab1=""
                                        class="figure figure-thumb"
                                      >
                                        <a
                                          data-v-1e04aab1=""
                                          :href="'/detail/' + child.goods_id"
                                          target="_blank"
                                        >
                                          <div
                                            class="img-box"
                                            style="width:80px;height:80px;"
                                          >
                                            <el-image
                                              :src="child.goods_image"
                                            ></el-image>
                                          </div>
                                        </a>
                                      </div>
                                      <p data-v-1e04aab1="" class="name">
                                        <a
                                          data-v-1e04aab1=""
                                          :href="'/detail/' + child.goods_id"
                                          target="_blank"
                                          >{{ child.goods_name }}</a
                                        ><!---->
                                      </p>
                                      <p
                                        data-v-1e04aab1=""
                                        class="price"
                                        v-show="item.status !== 'TO_REPLY'"
                                      >
                                        价格：<span
                                          style="text-decoration:line-through;color:#aaa"
                                        >
                                          {{ child.price }}</span
                                        >
                                        元
                                      </p>
                                      <p
                                        data-v-1e04aab1=""
                                        class="price"
                                        v-show="item.status !== 'TO_REPLY'"
                                      >
                                        优惠价：<span
                                          style="font-size:16px;color:red;"
                                        >
                                          {{ child.reply_price }}</span
                                        >
                                        元 x
                                        <span
                                          style="font-size:16px;color:red;"
                                          >{{ child.qty }}</span
                                        >
                                        =
                                        <span style="font-size:16px;color:red;">
                                          {{ child.reply_amount }}</span
                                        >
                                        元
                                      </p>
                                      <p
                                        data-v-1e04aab1=""
                                        class="price"
                                        v-show="item.status !== 'TO_ORDER'"
                                      >
                                        价格：<span
                                          style="font-size:16px;color:red;"
                                        >
                                          {{ child.price }}</span
                                        >
                                        元 x
                                        <span
                                          style="font-size:16px;color:red;"
                                          >{{ child.qty }}</span
                                        >
                                        =
                                        <span style="font-size:16px;color:red;">
                                          {{ child.amount }}</span
                                        >
                                        元
                                      </p>
                                    </li>
                                  </ul>
                                </td>
                                <td data-v-059c1862="" class="order-actions">
                                  <a
                                    data-v-059c1862=""
                                    class="btn btn-small btn-line-gray"
                                    @click="goCheckOut(item)"
                                  >
                                    生成采购单
                                  </a>
                                  <a
                                    data-v-059c1862=""
                                    href="javascript:void(0)"
                                    class="btn btn-small btn-line-gray btn-contract"
                                    >联系客服
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </li>
                    </ul>
                    <el-pagination
                      hide-on-single-page
                      style="text-align:right; margin-top:10px;"
                      layout="total, sizes, prev, pager, next, jumper"
                      :page-sizes="[10, 20, 50, 100]"
                      :page-size="pagination.limit"
                      :current-page="pagination.current"
                      :total="pagination.total"
                      @size-change="changePageSize"
                      @current-change="changeCurrentPage"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LeftNav from "../Layout/LeftNav.vue";
import { api } from "@/assets/js/util.js";
export default {
  name: "Profile",
  components: {
    "left-nav": LeftNav,
  },
  data() {
    return {
      table_data: [],
      pagination: {},
      form: {},
      is_read_only: false,
      active_tab: "ALL",
      is_loading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    goCheckOut(inquiry) {
      let that = this;
      let params = {
        inquiry_id: inquiry.id,
        from: "inquiry",
      };
      api.post("order/preview", params).then(function(res) {
        if (res.code) {
          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
            onClose: function() {
              that.$router.push("/order/checkout/" + res.data.id);
            },
          });
        } else {
          that.$message(res.msg);
          return false;
        }
      });
    },
    goDetail(item) {
      this.$router.push("/inquiry/detail/" + item.id);
    },
    onClickTab(name) {
      this.active_tab = name;
      this.getData();
    },
    getTabClass(name) {
      if (name == this.active_tab) {
        return "active";
      }
    },
    changePageSize(page_size) {
      this.pagination.limit = page_size;
      this.getData();
    },
    changeCurrentPage(current) {
      this.pagination.current = current;
      this.getData();
    },
    getData() {
      let that = this;
      that.is_loading = true;
      let params = Object.assign(this.form, {
        page: that.pagination.current,
        limit: that.pagination.limit,
        status: that.active_tab,
      });
      api.get("inquiry/list", params).then(function(res) {
        if (res.code) {
          that.table_data = res.data;
          that.pagination.total = res.count;
          that.pagination.current = res.page;
          that.pagination.limit = res.limit;
          that.is_loading = false;
        }
      });
    },
  },
};
</script>
